<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    height="60"
    ref="appBar"
  >
    <AppBarButton
      :to="`/admin-dashboard`"
      icon="mdi-view-dashboard"
      tooltipText="Dashboard"
    />
    <v-spacer />

    <h3
      v-if="Object.keys(currentlyViewedChallenge).length > 0 && currentlyViewedChallenge.name.length > 0"
      class="challenge-name">
      {{ currentlyViewedChallenge.name }}
    </h3>
    <!-- <AppBarButton
      to="/whiteboard"
      icon="mdi-draw"
      tooltipText="Canvas"
      :disabled="currentlyViewedChallenge === null"
    /> -->

    <v-spacer />

    <AppBarButton
      icon="mdi-arrow-collapse-down"
      tooltipText="Download"
      :show="$route.name == 'whiteboard'"
      @click="downloadCanvas"
    />

    <AppBarButton
      icon="mdi-image-filter-center-focus"
      tooltipText="Centre canvas"
      :show="$route.name == 'whiteboard'"
      @click="centerCanvas"
    />

    <Notifications />

    <UserProfile />

    </v-app-bar>
</template>

<script>
// Components
import UserProfile from './UserProfile'
import AppBarButton from './utils/AppBarButton'
import Notifications from './Notifications'

// Utilities
import { mapState, mapActions } from 'vuex'

export default {
  name: 'AppBar',

  components: {
    AppBarButton,
    Notifications,
    UserProfile
  },

  created () {
    console.log(this.$route)
  },

  data: () => ({
    fileMenu: [
      'settings'
    ]
  }),

  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      currentlyViewedChallenge: state => state.challenge.currentlyViewedChallenge
    })
  },

  methods: {
    ...mapActions('canvas', ['centerCanvas', 'downloadCanvas'])
  }
}
</script>
<style lang="sass" scoped>
  #app-bar
    background-image: linear-gradient(to right, rgb(255, 149, 24), rgb(255, 70, 70))
    position: fixed
    z-index: 999

  .challenge-name
    border: 2px solid black
    padding: 2px 8px 2px 8px
    border-radius: 4px
</style>
